import { axiosRequest } from '@/store/api/base/api.base';
import type { TypeApiError, TypePageInfo } from '@/types/api/types.api';

type TypeWalkPage<T> = { items: T[]; page?: TypePageInfo | null };

type TypeWalkOptions<P> = {
    url: string;
    fallback: string;
    params?: Record<string, unknown>;
    pageSize?: number;
    maxPages?: number;
    onPage?: (page: P) => void;
};

export const walkPages = async <T, P extends TypeWalkPage<T> = TypeWalkPage<T>>({
    url, fallback, params = {}, pageSize = 200, maxPages = 40, onPage,
}: TypeWalkOptions<P>): Promise<{ data: T[] } | { error: TypeApiError }> => {
    const items: T[] = [];
    let cursor: string | null = null;

    for (let page = 0; page < maxPages; page += 1) {
        const result = await axiosRequest({ url, params: { ...params, limit: pageSize, ...(cursor ? { cursor } : {}) } }, { fallback });
        if ('error' in result) return result;
        const body = result.data as P | null;
        if (!body) break;

        items.push(...body.items);
        onPage?.(body);
        cursor = body.page?.hasMore ? body.page.nextCursor : null;
        if (!cursor) break;
    }

    return { data: items };
};

export default walkPages;
